function poemsReducer(state = {
    poems: null,
    query: "",
    filterByQafiyatId: "",
    searchResults: null,
    loading: true
}, action) {

    switch (action.type) {
        case 'POEMS_LOADING':
            return { ...state,
                loading: true
            };
        case 'FILTER_BY_QUERY':
            return { ...state,
                query: action.query,
                searchResults: action.searchResults
            };
        case 'FILTER_BY_QAFIYAT':
            return { ...state,
                filterByQafiyatId: action.filterByQafiyatId
            };
        case 'LOADED':
            return { ...state,
                loading: false,
                poems: action.poems,
                quafiyatList: action.quafiyatList
            };

    }
    return state;
}

function loadingAction() {
    return dispatch => {
        dispatch({
            type: 'POEMS_LOADING'
        });

        fetch("http://www.almotanabbi.com/ws1.0/getPoemsList.do").then(response => {
            response.json().then(poems => {
                dispatch({
                    type: 'LOADED',
                    poems: poems,
                    quafiyatList: getUniqueQafiyat(poems)
                });
            });
        });
    }
}

function filterByQafiyat(qafiyatId) {
    return dispatch => {
        dispatch({
            type: 'FILTER_BY_QAFIYAT',
            filterByQafiyatId: qafiyatId
        });
    }
}

function filterByQuery(query) {
    return dispatch => {

        fetch("http://www.almotanabbi.com/ws1.0/searchPoems.do?q=" + query).then(response => {
            response.json().then(searchResults => {
                dispatch({
                    type: 'FILTER_BY_QUERY',
                    query: query,
                    searchResults: searchResults
                });
            });
        });
    }
}

function getUniqueQafiyat(poems) {
    const quafiyatList = poems.map(poem => {
        return {
            id: poem.letterId,
            name: poem.letter
        };
    });
    let quafiyatListSet = [];
    quafiyatList.forEach(qafiya => {
        quafiyatListSet[qafiya.id] = qafiya;
    });
    return quafiyatListSet;
}

export {
    poemsReducer,
    loadingAction,
    filterByQafiyat,
    filterByQuery
};


// WEBPACK FOOTER //
// ./src/PoemsListReducer.js